import { FC } from "react";
import Modal from "components/Modal";
import { FormInput, FormNotice, formStyles as styles } from "shared/ui";
import { useChangeEmail } from "../model/useChangeEmail";

interface Props {
  currentEmail: string | null;
  onClose: () => void;
}

export const ChangeEmailModal: FC<Props> = ({ currentEmail, onClose }) => {
  const { email, setEmail, submit, isSubmitting, error, pendingEmail } =
    useChangeEmail(currentEmail);

  if (pendingEmail) {
    return (
      <Modal isOpen onClose={onClose} title="Change Email">
        <FormNotice onClose={onClose}>
          We sent a confirmation link to {pendingEmail}. Open it to finish
          changing your email.
        </FormNotice>
      </Modal>
    );
  }

  return (
    <Modal isOpen onClose={onClose} title="Change Email">
      <form
        className={styles.form}
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          submit();
        }}
      >
        <p className={styles.hint}>
          If you want to change your email, enter a new address. We&apos;ll send
          a confirmation link to it.
        </p>
        <FormInput
          type="email"
          placeholder="you@example.com"
          autoComplete="email"
          value={email}
          error={error}
          onValueChange={setEmail}
          disabled={isSubmitting}
          autoFocus
        />
        <button
          type="submit"
          className={styles.submitButton}
          disabled={isSubmitting || !email.trim()}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </Modal>
  );
};
